import { Tooltip } from '@mui/material'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import InfoBanner from 'ui/components/InfoBanner/InfoBanner'

export default function InfoBannerWithTooltip(): ReactElement {
  const { t } = useTranslation()

  return (
    <Tooltip
      arrow
      placement="top"
      title={t('Publishing a production plan will copy the latest result to the Production Plan module.')}
    >
      <div className="w-fit mb-5">
        <InfoBanner text={t('What does it mean to publish?')} style="info" variant="text" />
      </div>
    </Tooltip>
  )
}
